import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button, Row, Col, FormGroup, Input } from "reactstrap";
import Select from "react-select";
import {
  columnHeaderStyle,
  columnBodyStyle,

} from "./TemplateCurvesAnalytes";

export const ModalCurveAnalytes = ({
  visible,
  setVisible,
  formCurves,
  dataMethodCurve,
  saveSendInfoAnalyteRanges,
  handleConfigurationCurves,
  genderOptions, handleChangeGender, enabledFields, handleEditorChange,
  handleChangeAgeField, handleUnlockRow, handleRemoveSubRow,
  handleChangeTimeCurves, getAvailableTimeOptions, handleAddSubRow, loadingSaveCurve
}) => {


  const uniqueTimes = formCurves.arrayCurvesRanges
    .filter(item => item.id_method?.value === formCurves.id_methodCurve?.value) // solo la metodología actual
    .reduce((acc, item) => {
      if (!acc.some(t => t.tiempo?.value === item.tiempo?.value)) {
        acc.push(item);
      }
      return acc;
    }, [])
    .sort((a, b) => (a.tiempo?.value ?? 0) - (b.tiempo?.value ?? 0));


  const [expandedRowsIds, setExpandedRowsIds] = useState({});


  const handleRowToggle = (e) => {
    setExpandedRowsIds(e.data);
  };

  // ---------------- Row expansion template ----------------
  const rowExpansionTemplate = (rowData) => {

    // const curvesForThisTime = formCurves.arrayCurvesRanges.filter(
    //   c => c.id_time === rowData.id_time
    // );

    const curvesForThisTime = formCurves.arrayCurvesRanges.filter(
      c => c.id_time === rowData.id_time && c.id_method?.value === formCurves.id_methodCurve?.value
    );



    return (
      <div className="p-3">
        <div className="table-responsive">


          <DataTable
            value={curvesForThisTime}
            dataKey="id"
            responsiveLayout="scroll"
            emptyMessage={null}
          >
            <Column
              header="Género"
              body={rowData => (
                <Select
                  name="id_gender"
                  isClearable
                  placeholder="Selecciona una opción"
                  options={genderOptions}
                  value={
                      rowData.id_gender === null
                        ? genderOptions.find(g => g.label === "Indistinto")
                        : genderOptions.find(g => g.value === rowData.id_gender) || null
                    }
                  onChange={selected => handleChangeGender(selected, rowData.id)}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                    control: base => ({ ...base, minHeight: 40, fontSize: 14, width: "100%" }),
                  }}
                />
              )}
              headerStyle={{ ...columnHeaderStyle, width: "200px" }}
              style={{ ...columnBodyStyle, width: "200px" }}
            />


            {/* Edad Inicial-Final */}
            <Column
              header="Edad Inicial-Final"
              body={(rowData) => (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px", justifyItems: "center", alignItems: "center", padding: "8px" }}>

                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <label>Año inicio</label>
                    <input
                      type="number"
                      value={rowData.years_from ?? ""}
                      onChange={(e) => handleChangeAgeField(rowData.id, "years_from", e.target.value)}
                      className="form-control form-control-sm input-air-primary text-center"
                      style={{ width: "100%", maxWidth: "120px" }}
                    />
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <label>Mes inicio</label>
                    <input
                      type="number"
                      value={rowData.months_from ?? ""}
                      onChange={(e) => handleChangeAgeField(rowData.id, "months_from", e.target.value)}
                      className="form-control form-control-sm input-air-primary text-center"
                      style={{ width: "100%", maxWidth: "120px" }}
                    />
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <label>Día inicio</label>
                    <input
                      type="number"
                      value={rowData.days_from ?? ""}
                      onChange={(e) => handleChangeAgeField(rowData.id, "days_from", e.target.value)}
                      className="form-control form-control-sm input-air-primary text-center"
                      style={{ width: "100%", maxWidth: "120px" }}
                    />
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <label>Año final</label>
                    <input
                      type="number"
                      value={rowData.years_to ?? ""}
                      onChange={(e) => handleChangeAgeField(rowData.id, "years_to", e.target.value)}
                      className="form-control form-control-sm input-air-primary text-center"
                      style={{ width: "100%", maxWidth: "120px" }}
                    />
                  </div>
                  
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <label>Mes final</label>
                    <input
                      type="number"
                      value={rowData.months_to ?? ""}
                      onChange={(e) => handleChangeAgeField(rowData.id, "months_to", e.target.value)}
                      className="form-control form-control-sm input-air-primary text-center"
                      style={{ width: "100%", maxWidth: "120px" }}
                    />
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <label>Día final</label>
                    <input
                      type="number"
                      value={rowData.days_to ?? ""}
                      onChange={(e) => handleChangeAgeField(rowData.id, "days_to", e.target.value)}
                      className="form-control form-control-sm input-air-primary text-center"
                      style={{ width: "100%", maxWidth: "120px" }}
                    />
                  </div>

                </div>
              )}
              headerStyle={columnHeaderStyle}
              style={columnBodyStyle}
            />

            <Column
              header="Rangos Numéricos"
              body={(rowData) => (
                <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" }}>

                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <label>Rango Mínimo</label>
                    <input
                      type="number"
                      value={rowData.min || ""}
                      onChange={(e) => handleEditorChange(e, rowData.id, "min")}

                      disabled={enabledFields[rowData.id]?.min === false}
                      className="form-control form-control-sm input-air-primary text-center"
                      style={{ width: 150 }}
                    />
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <label>Rango Máximo</label>
                    <input
                      type="number"
                      value={rowData.max || ""}
                      onChange={(e) => handleEditorChange(e, rowData.id, "max")}
                      disabled={enabledFields[rowData.id]?.max === false}
                      className="form-control form-control-sm input-air-primary text-center"
                      style={{ width: 150 }}
                    />
                  </div>
                </div>
              )}
              headerStyle={columnHeaderStyle}
              style={columnBodyStyle}
            />

            <Column
              header="Rango de Texto"
              body={(rowData) => (
                <textarea
                  className="form-control form-control-sm input-air-primary"
                  value={rowData.text || ""}
                  onChange={(e) => handleEditorChange(e, rowData.id, "text")}
                  disabled={enabledFields[rowData.id]?.text === false}

                  style={{ width: "100%", resize: "vertical" }}
                  rows={3}
                />
              )}
              headerStyle={columnHeaderStyle}
              style={columnBodyStyle}
            />


            <Column
              header="Acciones"
              body={(rowData) => (
                <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                  <button
                    onClick={() => handleUnlockRow(rowData.id)}
                    className="btn btn-warning btn-sm"
                    title="Desbloquear fila"
                  >
                    <i className="fa fa-eraser" />
                  </button>

                  <button
                    onClick={() => handleRemoveSubRow(rowData.id_time, rowData.id)}
                    className="btn btn-danger btn-sm"
                    title="Eliminar subfila"
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
              headerStyle={{
                backgroundColor: "#0d3b59",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "12px",
                textAlign: "center",
              }}
              style={{
                fontSize: "12px",
                textAlign: "center",
                padding: "5px",
              }}
            />

          </DataTable>
        </div>

        <Row className="mt-3">
          <Col xs="6">
            <Button
              color="primary"
              size="sm"
              onClick={() => handleAddSubRow(rowData.id_time)}
            >
              <i className="fa fa-plus mr-1"></i> Agregar fila
            </Button>
          </Col>
        </Row>
      </div>
    );
  };





  return (

    <Dialog
      header="Valores de Referencia"
      visible={visible}
      maximizable
      style={{ width: "100vw" }}
      headerStyle={{ backgroundColor: "#0d3b59", color: "white", fontWeight: "bold" }}
      onHide={() => setVisible(false)}
    >
      <Row>
        <Col sm="6" className="pt-2">
          <FormGroup>
            <label className="f-w-600" style={{ color: "#0d3b59" }}>Metodología</label>
            <Select
              name="id_methodCurve"
              isClearable={true}
              placeholder="Selecciona un Analito"
              options={dataMethodCurve}
              value={formCurves.id_methodCurve}
              onChange={(e) => handleConfigurationCurves(e, "id_methodCurve")}
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </FormGroup>
        </Col>

        <Col sm="6" className="pt-2">
          <FormGroup>
            <label className="f-w-600" style={{ color: "#0d3b59" }}>Tiempos</label>
            <Select
              name="id_time"
              isClearable={true}
              placeholder="Selecciona un tiempo"
              options={getAvailableTimeOptions()} 
              value={null} 
              onChange={(selectedOption) => handleChangeTimeCurves(selectedOption)}

              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />


          </FormGroup>
        </Col>
      </Row>

      {/* Tabla principal */}
      <div className="mt-3">

        <div className="table-responsive">

          <DataTable
            value={uniqueTimes}
            dataKey="id_time"
            expandedRows={expandedRowsIds}
            onRowToggle={handleRowToggle}
            rowExpansionTemplate={rowExpansionTemplate}
            className="p-datatable-sm"
            responsiveLayout="scroll"
            emptyMessage={
              <div className="text-center">
                <img
                  src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                  style={{ width: "25%" }}
                  alt="Sin resultados"
                />
                <br />
                <p className="badge badge-light-primary mt-2" style={{ fontSize: 15 }}>
                  No hay tiempos seleccionados.
                </p>
              </div>
            }
          >
            <Column
              expander
              headerStyle={{
                backgroundColor: "#1a5379",
                color: "#fff",
                fontWeight: "bold",
                textAlign: "center",
                width: "3em",
              }}
            />
            <Column
              header="Tiempos"
              field="id_curve_time"
              body={(rowData) => <strong>{rowData.tiempo?.label || ""}</strong>}


              headerStyle={{
                backgroundColor: "#1a5379",
                color: "#fff",
                fontWeight: "bold",
                textAlign: "center",
              }}
              style={{
                fontSize: 12,
                padding: 8,
                color: "black",
                backgroundColor: "#f5f5f5",
              }}
            />
          </DataTable>
        </div>

        <div className="d-flex justify-content-end mt-3">
          <Button
            color="info"
            size="sm"
            className="mr-2"
            onClick={saveSendInfoAnalyteRanges}
            disabled={loadingSaveCurve} 
          >
            {loadingSaveCurve ? (
              <>
                <i className="fa fa-spinner fa-spin mr-1"></i> Guardando...
              </>
            ) : (
              <>
                <i className="fa fa-save mr-1"></i> Guardar
              </>
            )}
          </Button>


        </div>

      </div>
    </Dialog>
  );
};
